export default {
  title: "Se désabonner",
  processing: "Traitement de votre demande de désabonnement...",
  success_title: "Désabonné avec succès",
  success_message: "Vous avez été désabonné avec succès de notre liste de diffusion.",
  error_title: "Échec de la désinscription",
  error_message:
    "Nous n'avons pas pu traiter votre demande de désabonnement. Veuillez réessayer ultérieurement.",
  go_home: "Aller à l'accueil",
};
